import {Alert} from '@mui/material'
import {styled} from '@mui/material/styles'
import theme from '../../../../themes'

export const StyledAlert = styled(Alert)(() => ({
  [`.MuiAlert-action`]: {
    [`& .MuiIconButton-root`]: {
      color: theme.palette.common.black
    }
  }
}))
